import { gql } from '@apollo/client';

export default gql`
  query TaxjarCheckoutConfiguration {
    taxjarCheckoutConfiguration {
      globalEnabled
      renewalEnabled
    }
    partnerLocations {
      id
      name
      active
      taxjarCheckoutEnabled
    }
  }
`;
